const host = 'pass.ligastavok.ru'
const projectPath = ''
export default {
  host,

  name: 'L1GAPASS',

  basePath: projectPath,
  baseURL: `https://${host}${projectPath}/`,

  startSeasonDate: new Date('2024-10-09T11:00:00.000+03:00').getTime(),

  defaultLocale: 'ru',

  shareImageUrl: `https://${host}/static/images/share.png`,
  siteName: 'ligapass',
  parentSiteName: 'Лига ставок',
  parentSiteLink: 'https://www.ligastavok.ru',
  ogTitle: 'Выигрывай призы от LIGAPASS',
  ogDescription:
    'Выполняй задания, находи спрятанные коды и получай крутые призы. Не упусти возможность получить фрибеты и другие крутые подарки от LIGAPASS.',

  auth: {
    redirect: '/',
    callbackPath: `${projectPath}/callback/`
  },
  mainCoinCode: 'liga',
  shopGuideUrl: '',
  tgSupportLink: 'https://t.me/l1ga_pass',
  bonusesUrl: ''
}
